import CustomOverlapLoader from "@/components/Loader/CustomOverLapLoader";
import { Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useMemo } from "react";

export default function CustomCheckboxList({
  data,
  selected,
  handleToggleCheckBox,
  isLoading,
}: CustomCheckboxListProps) {
  const memoizedList = useMemo(
    () => (
      <List
        sx={{
          width: "100%",
          height: "100%",
        }}
      >
        {data?.map((value) => {
          return (
            <li key={value.id}>
              <ul style={{ padding: 0 }}>
                {value?.name && value?.children?.[0] && (
                  <Typography
                    variant="h5Reg"
                    color={"text.secondary"}
                    sx={{ py: "10px" }}
                  >
                    {value.name}
                  </Typography>
                )}

                {value?.children?.map(
                  (item: Record<string, any>, index: number) => {
                    const labelId = `checkbox-list-label-${item.name}`;
                    return (
                      <ListItem
                        key={`${item.id}${index}`}
                        disablePadding
                        sx={{
                          margin: 0,
                          padding: 0,

                          pl: "10px",
                          "&:hover": {
                            backgroundColor: "none",
                          },
                        }}
                      >
                        <ListItemButton
                          role={undefined}
                          onClick={() => handleToggleCheckBox(item)}
                          disableRipple
                          sx={{
                            width: "24px",
                            height: "24.61px",
                            padding: 0,
                            "&:hover": {
                              backgroundColor: "inherit",
                            },
                          }}
                          dense
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                            }}
                          >
                            <Checkbox
                              edge="start"
                              checked={selected.indexOf(item.id) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            id={labelId}
                            primary={item.name}
                            sx={{
                              ".MuiTypography-root": {
                                fontSize: "16px",
                                fontWeight: "400",
                                lineHeight: "24px",
                                fontFamily: "Poppins",
                                letterSpacing: "0.00938em",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                              },
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  }
                )}
              </ul>
            </li>
          );
        })}
      </List>
    ),
    [JSON.stringify(selected), data]
  );
  return (
    <CustomOverlapLoader isLoading={isLoading}>
      {isLoading ? (
        <List
          sx={{
            width: "100%",
            height: "350px",
          }}
        />
      ) : (
        memoizedList
      )}
    </CustomOverlapLoader>
  );
}

interface CustomCheckboxListProps {
  data: Record<string, any>[];
  selected: any[];
  handleToggleCheckBox: (item: any) => void;
  isLoading: boolean;
}
